import { useField } from 'formik';
import LifecareStudioField from './LifecareStudioField';
import LifecareStudioTable from './LifecareStudioTable';
import XAutoGrowTextarea from '../common/XAutoGrowTextarea';
import {
  dangerInlineButtonClasses,
  subsectionHeaderClasses,
  subsectionTitleInputClasses,
  subsectionTitleMinHeight,
  subsectionWrapperClasses,
} from './lifecareStudioClasses';
import { planFieldPaths } from '../../utils/lifecarePlanUtils';

const LifecareStudioSubsection = ({
  subsectionIndex,
  subsection,
  subtotal,
  moveTargets,
  onRemoveSubsection,
  onAddRow,
  onRemoveRow,
  onMoveRow,
  onRowFieldChange,
}) => {
  const titleFieldName = planFieldPaths.subsectionField(subsectionIndex, 'title');
  const [titleField] = useField(titleFieldName);
  return (
    <div className={subsectionWrapperClasses}>
      <div className={subsectionHeaderClasses}>
        <XAutoGrowTextarea
          className={subsectionTitleInputClasses}
          minHeight={subsectionTitleMinHeight}
          singleLine
          value={titleField.value || ''}
          onChange={titleField.onChange}
          onBlur={titleField.onBlur}
          name={titleFieldName}
          placeholder="Subsection title"
        />
        <button
          type="button"
          className={dangerInlineButtonClasses}
          onClick={() => onRemoveSubsection({ subsectionIndex })}
        >
          <i className="fa fa-trash" />
          <span>Remove subsection</span>
        </button>
      </div>
      <LifecareStudioField
        name={planFieldPaths.subsectionField(subsectionIndex, 'content')}
        placeholder="Content"
        multiline
      />
      <LifecareStudioTable
        rows={subsection?.tables}
        subtotal={subtotal}
        moveTargets={moveTargets}
        onAddRow={() => onAddRow({ subsectionIndex })}
        onRemoveRow={({ rowIndex }) => onRemoveRow({ subsectionIndex, rowIndex })}
        onMoveRow={({ rowIndex, targetSubsectionIndex }) =>
          onMoveRow({ subsectionIndex, rowIndex, targetSubsectionIndex })
        }
        onFieldChange={({ rowIndex, field, value }) =>
          onRowFieldChange({ subsectionIndex, rowIndex, field, value })
        }
      />
    </div>
  );
};

export default LifecareStudioSubsection;
